<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #37ef00 !important;
          border-color: #37ef00 !important;
        "
        @click="cargarLogActividades((excel_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarLogActividades((excel_btn = ''), (pdf_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label for="fecha-desde">Fecha (desde): </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Usuario:" label-for="mc-usuario">
            <vue-simple-suggest
              ref="suggestComponent"
              v-model="finderfieldusuario.modelo.texto"
              pattern="\w+"
              prop="chofer"
              label="Chofer"
              :list="obtener_data_usuario"
              :max-suggestions="10"
              :min-length="2"
              :debounce="500"
              :filter-by-query="false"
              :prevent-submit="true"
              :controls="{
                selectionUp: [38, 33],
                selectionDown: [40, 34],
                select: [13, 36],
                hideList: [27, 35],
              }"
              :nullable-select="true"
              placeholder="Search information..."
              value-attribute="token"
              display-attribute="value"
              @select="onSuggestSelectUsuario"
              @input="onInputUsuarioSuggest"
            >
              <div>
                <b-input-group>
                  <b-form-input
                    v-model="finderfieldusuario.modelo.texto"
                    placeholder="Usuario"
                  />
                  <b-input-group-append is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-append>
                </b-input-group>
                <div
                  v-if="finderfieldusuario.cargando && !finderfieldusuario.data"
                  style="
                    min-height: 857px;
                    height: fit-content;
                    width: 100%;
                    position: absolute;
                  "
                >
                  <img
                    class="loading-gif"
                    src="@/assets/images/bus/loading.gif"
                    alt="loading"
                    style="width: 45px"
                  />
                </div>
              </div>
              <template
                slot="misc-item-above"
                slot-scope="{ suggestions, query }"
              >
                <div class="misc-item">
                  <span>Buscando '{{ query }}'.</span>
                </div>
                <template v-if="suggestions.length > 0">
                  <div class="misc-item">
                    <span
                      >{{ suggestions.length }} resultado(s) encontrado(s)</span
                    >
                  </div>
                  <hr />
                </template>
                <div v-else-if="!finderfieldusuario.loading" class="misc-item">
                  <span>No hay resultados</span>
                </div>
              </template>

              <div
                slot="suggestion-item"
                slot-scope="scope"
                :title="scope.suggestion.description"
              >
                <div class="text">
                  <span v-html="boldenSuggestion(scope)" />
                </div>
              </div>

              <div
                v-if="finderfieldusuario.loading"
                slot="misc-item-below"
                slot-scope="{ suggestions }"
                class="misc-item"
              >
                <span>Cargando...</span>
              </div>
            </vue-simple-suggest>
          </b-form-group>
        </b-col>
        <!--        <b-col md="4">-->
        <!--          <b-form-group>-->
        <!--            <label>Usuario:</label>-->
        <!--            <b-form-input-->
        <!--              name="usuario"-->
        <!--              v-model="usuario"-->
        <!--              placeholder="Buscar por usuario"-->
        <!--              type="text"-->
        <!--              class="d-inline-block"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </b-col>-->
        <b-col md="4">
          <b-form-group>
            <label>Descripción:</label>
            <b-form-input
              name="descripcion"
              v-model="descripcion"
              placeholder="Buscar por descripción"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2" @click="filtrar">
          <b-button variant="primary" size="sm">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(fecha_hora)="data">
              {{ new Date(data.value).toLocaleString("pt-BR") }}
            </template>
            <template #cell(usuario)="data">
              {{ data.value.first_name }} {{ data.value.last_name }}
            </template>
            <template #cell(accion)="data">
              {{ procesarAcciones(data.value) }}
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            :small="true"
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BImg,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  BOverlay,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import actions from "@/assets/utils/utils";
import $ from "jquery";
import axios from "@/libs/axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import Vue from "vue";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

export default {
  components: {
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    flatPickr,
    BOverlay,
    VueSimpleSuggest,
  },
  data() {
    return {
      login_user: "",
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "fecha_hora",
          label: "Fecha",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario",
          label: "Usuario",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "accion",
          label: "Acción",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "descripcion",
          label: "Descripción",
          sortable: true,
          thClass: "text-center",
        },
      ],
      items: [],
      fecha_desde: "",
      fecha_hasta: "",
      usuario: "",
      descripcion: "",

      listaAcciones: [],

      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
      mostrarLoader: false,

      finderfieldusuario: {
        chosen: "",
        selected: null,
        modelo: { texto: "" },
        busqueda: { texto: "" },
        mode: "input",
        loading: false,
        cargando: false,
        data: null,
        dataCompleta: "",
      },

      token_usuario: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  mounted() {
    // Set the initial number of items
    actions.setearTitulo("");
    this.cargarLogActividades();
    this.totalRows = this.items.length;
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    cambiarPagina(value) {
      const pagina_actual = value;
      // this.currentPage = pagina_actual
      const limite_superior = value * this.perPage;
      const limite_inferior = (value - 1) * this.perPage;
      const desde = limite_inferior;
      const hasta = limite_superior;

      this.cargarLogActividades("", "", desde, hasta, pagina_actual);
    },
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("rep_log_actividades") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarLogActividades();
    },
    procesarAcciones(texto) {
      for (let acciones of this.listaAcciones) {
        if (texto === acciones.value) {
          return acciones.text;
        }
      }
    },
    cargarLogActividades(
      excel_btn = "",
      pdf_btn = "",
      desde = 0,
      hasta = 15,
      pagina_actual = 1
    ) {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query allLogactividades($usuario: String!, $descripcion: String!, $fechaDesde: String!, $fechaHasta: String!, $excel: String!, $pdf: String!, $desde: Int!, $hasta: Int!){
                    allLogactividades(usuario:$usuario, descripcion: $descripcion, fechaDesde:$fechaDesde, fechaHasta:$fechaHasta, excel:$excel, pdf:$pdf, desde: $desde, hasta: $hasta){
                        logactividades{
                            fecha_hora: fechaHora,
                            accion,
                            descripcion,
                            usuario{
                                first_name: firstName,
                                last_name: lastName
                            }
                        },
                        total,
                        dataarchivo,
                        listaAcciones{
                            value,
                            text
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            usuario: this.token_usuario,
            descripcion: this.descripcion,
            fechaDesde: this.fecha_desde,
            fechaHasta: this.fecha_hasta,
            excel: excel_btn,
            pdf: pdf_btn,
            desde,
            hasta,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.allLogactividades.status === "success") {
              if (response.data.data.allLogactividades.logactividades) {
                if (this.listaAcciones.length === 0) {
                  this.listaAcciones =
                    response.data.data.allLogactividades.listaAcciones;
                }
                this.items =
                  response.data.data.allLogactividades.logactividades;
                this.totalRows = response.data.data.allLogactividades.total;
                this.currentPage = 1;
                this.currentPageModificado = pagina_actual;
              } else {
                var data = response.data.data.allLogactividades.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Log de actividades.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Log de actividades.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async obtener_data_usuario(inputValue) {
      this.finderfieldusuario.cargando = true;
      let results;
      await axios
        .post("api", {
          query: `query autocompletarUsuario($texto: String!){
                    autocompletarUsuario(texto:$texto){
                        lista{
                            token,
                            label,
                            value
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            texto: inputValue,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.autocompletarUsuario.status === "success") {
              // const datos = response.data.data.autocompletar.lista
              results = response.data.data.autocompletarUsuario.lista;
              this.finderfieldusuario.data = results;
              this.finderfieldusuario.cargando = false;
            }
          }
        });
      const promise = new Promise((resolve, reject) => {
        resolve(results);
      });

      return promise;
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      const result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
      return result.replace(
        new RegExp(`(.*?)(${texts.join("|")})(.*?)`, "gi"),
        "$1<b>$2</b>$3"
      );
    },
    onSuggestSelectUsuario(suggest) {
      this.finderfieldusuario.selected = suggest;
      this.token_usuario = this.finderfieldusuario.selected.token;
    },
    onInputUsuarioSuggest(newValue) {
      if (
        this.finderfieldusuario &&
        this.finderfieldusuario.data &&
        !this.finderfieldusuario.data.some((e) => e.value === newValue)
      ) {
        this.token_usuario = "";
      }
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
.vue-simple-suggest.designed .input-wrapper input {
  width: auto !important;
}
</style>
